var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Category-Page","stroke":"none","strokeWidth":"1","fillRule":"evenodd"},React.createElement("g",{"id":"Glowforge---Acrylic-Open","transform":"translate(-331.000000, -485.000000)"},React.createElement("g",{"id":"Group","transform":"translate(35.000000, 444.000000)"},React.createElement("g",{"id":"Effect","transform":"translate(290.000000, 0.000000)"},React.createElement("g",{"id":"2-color","transform":"translate(1.000000, 35.000000)"},React.createElement("polygon",{"id":"Mask","points":"8.73937247 16.3633603 5 12.6232287 6.34134615 11.2811235 8.67484818 13.6146255 15.5964069 6 17 7.27682186"})))))));
}

Checkmark.defaultProps = {"viewBox":"0 0 12 11","version":"1.1"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
